$(document).ready(function () {

    function window_inner_height(){
        let header_height = ($('.announcement-bar-section').length > 0)? $('.section-header').outerHeight() + $('.announcement-bar-section').outerHeight() : $('.section-header').outerHeight();
        $('html').css('--window-height',($(window).height() - header_height + 'px'));
    }
    window_inner_height();
    $(window).on('resize',function(){
        window_inner_height();
    });

    $('#menu-drawer-close').click(function(e){
        e.preventDefault();
        $('#Details-menu-drawer-container .header__icon--menu').click();
        $('.menu-drawer__menu .has-dropdown a.active').removeClass('active');
        $('.menu-drawer__menu .has-dropdown .menu-drawer__dropdown').slideUp();
    });

    $('body').on('click', '.menu-drawer__menu a[href*="#"],.menu-drawer-image-block a[href*="#"]', function (e) {
        const href = $(this).attr('href');
        const currentPath = window.location.pathname;
        const linkPath = href.split('#')[0];
        if (linkPath === currentPath) {
            e.preventDefault();
            $('#menu-drawer-close').trigger('click'); 
            const id = href.split('#')[1];
            document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
        }
    });

    $('#menu-drawer-cart').click(function(e){
        e.preventDefault();
        $('#menu-drawer-close').trigger('click');
        document.querySelector('cart-drawer')?.open();
    });


    $('body').on('click', '.footer-block--menu a[href*="#"]', function (e) {
        const href = $(this).attr('href');
        const currentPath = window.location.pathname;
        const linkPath = href.split('#')[0];
        if (linkPath === currentPath) {
            e.preventDefault();
            const id = href.split('#')[1];
            document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
        }
    });


    $('.menu-drawer__menu .has-dropdown > a').click(function(e){
        e.preventDefault();
        $(this).parents('li').siblings().find('a.active').removeClass('active');
        $(this).parents('li').siblings().find('.menu-drawer__dropdown').slideUp();
        $(this).toggleClass('active');
        $(this).next('.menu-drawer__dropdown').slideToggle();
    });


    // __________  Image Text Wave Two Infinite Scroll
    if($('.image-text-wave-two').length > 0){
        var scroll_speed = parseInt($('.image-text-wave-two .img-text-scroll-blocks').attr('data-desktop-speed'));
        if ($(window).width() < 750) {
            scroll_speed = parseInt($('.image-text-wave-two .img-text-scroll-blocks').attr('data-mobile-speed'));
        }
        $('.image-text-wave-two').find('.marquee').marquee({
            gap: 0,
            speed: scroll_speed * 1000,
            direction: 'left',
            duplicated: true,
        });
    }
    // __________  Image Text Wave Two Infinite Scroll

    // __________  Our Services Slider
    if($('.our-services').length > 0){

        var our_services_media_height = ($('.our-services .swiper-slide .media-block').innerHeight() / 2) + 'px';
        $('.our-services .swiper-button').css('--top',our_services_media_height)

        $('.our-services .our-service-slide .block-content-toggle').click(function(){
            $(this).next('.block-content').slideToggle();
            $(this).parents('.our-service-slide').toggleClass('active');
        });
    }
    // __________  Our Services Slider

    // __________  Image Text Wave Two Infinite Scroll
    if($('.text-with-images-scroll').length > 0){
        var text_with_images_scroll_speed_top = parseInt($('.text-with-images-scroll .media-block-scroll.to-top').attr('data-desktop-speed'));
        var text_with_images_scroll_speed_top_dir = 'up';
        var text_with_images_scroll_speed_btm = parseInt($('.text-with-images-scroll .media-block-scroll.to-bottom').attr('data-desktop-speed'));
        if ($(window).width() < 750) {
            text_with_images_scroll_speed_top = parseInt($('.text-with-images-scroll .media-block-scroll.to-top').attr('data-mobile-speed'));
            var text_with_images_scroll_speed_top_dir = 'left';
        }
        $('.text-with-images-scroll').find('.marquee.to-top').marquee({
            gap: 0,
            speed: text_with_images_scroll_speed_top * 1000,
            direction: text_with_images_scroll_speed_top_dir,
            duplicated: true,
            startVisible: true,
            delayBeforeStart: 2000
        });

        $('.text-with-images-scroll').find('.marquee.to-bottom').marquee({
            gap: 0,
            speed: text_with_images_scroll_speed_btm * 1000,
            direction: 'down',
            duplicated: true,
            startVisible: true,
            delayBeforeStart: 2000
        });
    }
    // __________  Image Text Wave Two Infinite Scroll


    // __________  Faqs
    if($('[data-faq-block]').length > 0){
        $('[data-faq-toggle]').click(function(){
            if ($(this).parents('[data-faqs-main="one-at-time"]').length > 0) {
                $(this).parents('[data-faq-block]').siblings('[data-faq-block].active').removeClass('active').find('[data-faq-content]').slideUp();
            }
            $(this).next('[data-faq-content]').slideToggle();
            $(this).parents('[data-faq-block]').toggleClass('active');
        });
    }
    // __________  Faqs


    // __________  Custom Select Box
    if($('.custom_select_box').length > 0){
        $('.custom_select_box .custom_select_toggle').click(function(e){
            e.preventDefault();
            $(this).next('.custom_select_content').slideToggle();
            $(this).parent('.custom_select_box').toggleClass('active');
        });
        $('.custom_select_box .custom_select_check input').on('change',function(){
            console.log($(this).val())
            $(this).parents('.custom_select_box').find('.toggle_label').text($(this).val());
            $(this).parents('.custom_select_box').removeClass('active').find('.custom_select_content').slideUp();
        });
    }
    // __________  Custom Select Box


    // __________  Blog Filter
    if($('#blog-filters').length > 0){
        $('#blog-filter-toggle').click(function(e){
            e.preventDefault();
            $(this).toggleClass('active');
            $('#blog-filters').slideToggle();
        });
    }
    // __________  Blog Filter

    // __________  Info Image Scroll
    if($('.info-with-image .info-blocks').length > 0){
        if ($(window).width() < 750) {
            scroll_speed = parseInt($('.info-with-image .info-blocks').attr('data-speed'));
            $('.info-with-image').find('.marquee').marquee({
                gap: 0,
                speed: scroll_speed * 1000,
                direction: 'left',
                duplicated: true,
            });
        }
    }
    // __________  Info Image Scroll


    $('body').on('click', '.copy-link', function (e) {
        e.preventDefault();
        navigator.clipboard.writeText($(this).data('link'));
        alert("Link copied!");
    });


    // Product Tab
    if($('#product-info-tabs').length > 0){
        var isDesktop = window.innerWidth >= 750;
        var productTabsSwiper = new Swiper('#product-info-tabs .product-info-tabs-wrap', {
            slidesPerView: 1,
            autoHeight: true,
            allowTouchMove: true,
            effect: isDesktop ? 'fade' : 'slide',
            fadeEffect: isDesktop ? { crossFade: true } : undefined,
            slideToClickedSlide: true,
            breakpoints: {
                750: {
                    slideToClickedSlide: false,
                    allowTouchMove: false
                }
            }
        });

        $('#product-info-tabs .product-info-tab-toggle').on('click', function () {
            var target = $(this).data('tab-target');
            if(target){
                $(this).addClass('active').siblings('.product-info-tab-toggle').removeClass('active');
                var index = $('#product-info-tabs .product-info-tab-content[data-tab="' + target + '"]').index();
                productTabsSwiper.slideTo(index);
            }
        });

        productTabsSwiper.on('slideChange', function () {
            var currentIndex = productTabsSwiper.activeIndex;
            var currentTab = $('.product-info-tab-content').eq(currentIndex).data('tab');
            $('.product-info-tab-toggles .product-info-tab-toggle').removeClass('active');
            $('.product-info-tab-toggles .product-info-tab-toggle[data-tab-target="' + currentTab + '"]').addClass('active');
        });
    }



    $('a[href]').each(function () {
        var link = $(this).attr('href');

        if (
        link &&
        link.indexOf('http') === 0 &&
        !link.includes(window.location.hostname)
        ) {
        $(this).attr('target', '_blank');
        $(this).attr('rel', 'noopener noreferrer');
        }
    });
    
});